import classes from './Card.module.scss';
import React, {memo} from "react";

const Card = memo(({children, ...props}) => {
    return (
        <div className={classes.card} style={{height: props.height}}>
            {children
                ? <div className={classes.children}>{children}</div>
                : <>
                    <div className={classes.name}>{props.name}</div>
                    <div className={classes.value}>{props.value} {props.unit}</div>
                </>}
        </div>
    );
});

export default Card;